export default "__VITE_ASSET__CYcVlSe3__"